import { render, staticRenderFns } from "./ClientEditForm.vue?vue&type=template&id=ff6c39da"
import script from "./ClientEditForm.vue?vue&type=script&lang=js"
export * from "./ClientEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports